import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from './user.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AppService } from './app.service';


@NgModule({
	declarations: [],
	providers: [UserService, AppService],
	imports: [
		CommonModule,
		MatSnackBarModule
	]
})
export class ProvidersModule { }
